import React from "react";
import { Grid, Button } from "@mui/material";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { TextField, InputAdornment } from "@mui/material";

const SearchBar = ({
  selected,
  setSelected,
  placeholder,
  handleSearch,
  handleUpdateGroupStatus,
}) => {
  return (
    <Grid container alignItems={"center"} justifyContent={"space-between"}>
      <TextField
        variant="outlined"
        placeholder={placeholder || "Search"}
        onChange={(e) => handleSearch && handleSearch(e)}
        InputProps={{
          sx: { ...searchTextfieldStyles },
          startAdornment: (
            <InputAdornment position="start">
              <SearchOutlinedIcon />
            </InputAdornment>
          ),
        }}
      />

      {selected && selected.length > 0 && (
        <Grid container justifyContent={"flex-end"} style={{ width: "auto", gap: 8 }}>
          <Button
            variant="contained"
            onClick={() => handleUpdateGroupStatus && handleUpdateGroupStatus("active")}
            style={actionButtonStyles}
          >
            Set Active
          </Button>
          <Button
            variant="contained"
            onClick={() => handleUpdateGroupStatus && handleUpdateGroupStatus("inactive")}
            style={actionButtonStyles}
          >
            Set Inactive
          </Button>
        </Grid>
      )}
    </Grid>
  );
};

export default SearchBar;

const searchTextfieldStyles = {
  height: 40,
  border: "none",
  borderColor: "#7676801F",
  borderRadius: 5,
  width: 320,
  background: "#7676801F",
  color: "#515563",
  fontSize: 14,
  fontWeight: 500,
  paddingLeft: 1,
  paddingRight: 2,
  fontFamily: "Avenir Book, sans-serif",
};

const actionButtonStyles = {
  background: "#00A7CD",
  textTransform: "none",
  fontFamily: "Avenir Book, sans-serif",
};

